import { selectSortableMapSorted } from '@epilot/journey-logic-commons/src/next/store'
import type { Step, StepId } from '@epilot/journey-logic-commons/src/types/next'

import type { WritableAppState } from '../types'

import { selectJourney, selectOriginalJourney } from './config'

export const selectAppError = (state: WritableAppState) => state.appError

export const selectJourneyStepsSorted = (state: WritableAppState) => {
  const journey = selectJourney(state)

  return selectSortableMapSorted<StepId, Step>(journey?.steps)
}

export const selectInitialStepId = (state: WritableAppState) =>
  state.initialStepId

export const selectInitialStepIndex = (state: WritableAppState) => {
  if (typeof state.initialStepId === 'undefined') return undefined

  const journey = selectJourney(state)

  if (journey) return journey.steps?.[state.initialStepId]?.orderIndex

  const index = selectOriginalJourney(state)?.steps.findIndex(
    (step) => step.stepId === state.initialStepId
  )

  if (index === undefined || index === -1) return undefined

  return index
}

export const selectDesignBuilderState = (state: WritableAppState) =>
  state.designBuilderState
